/* DSL Wishlist sharing — encode set into URL hash */
(function(){
  function shareUrl(){
    var ids = window.DSL_WISHLIST ? [...window.DSL_WISHLIST.get()] : [];
    if (!ids.length) return null;
    var hash = btoa(JSON.stringify(ids));
    return location.origin + "/pages/wishlist#" + hash;
  }
  function importFromHash(){
    if (!location.hash || !window.DSL_WISHLIST) return;
    try {
      var ids = JSON.parse(atob(location.hash.slice(1)));
      if (!Array.isArray(ids)) return;
      ids.forEach(function(id){ if (!window.DSL_WISHLIST.has(id)) window.DSL_WISHLIST.toggle(id); });
      if (window.DSL_AB) window.DSL_AB.track("wishlist_imported", {count: ids.length});
    } catch(e){}
  }
  document.addEventListener("click", function(e){
    if (!e.target.matches("[data-wishlist-share]")) return;
    e.preventDefault();
    var u = shareUrl();
    if (!u) { alert("Je wishlist is leeg."); return; }
    if (navigator.share) navigator.share({title:"Mijn DSL wishlist", url:u}).catch(function(){});
    else navigator.clipboard.writeText(u).then(function(){ alert("Wishlist link gekopieerd!"); });
  });
  if (location.pathname.indexOf("/wishlist") !== -1) importFromHash();
})();